/** Every dimension mirrors `NgoCampaignCard`, so the sheet does not jump when the query lands. */
function Block(props: { className: string }) {
	return <div className={`bg-ink/[0.06] rounded ${props.className}`} />;
}

export function NgoCampaignCardSkeleton() {
	return (
		<div
			aria-hidden
			className="flex animate-pulse flex-col gap-4 rounded-3xl bg-white p-4 shadow-[0_9px_24px_0_rgba(46,20,0,0.12)] sm:flex-row"
		>
			<div className="flex shrink-0 flex-col gap-4 sm:w-[292px]">
				<Block className="h-[197px] rounded-lg" />
				<div className="flex gap-10">
					<div className="flex flex-col gap-1">
						<Block className="h-6 w-16" />
						<Block className="h-3 w-24" />
					</div>
					<div className="flex flex-col gap-1">
						<Block className="h-6 w-16" />
						<Block className="h-3 w-24" />
					</div>
				</div>
			</div>

			<div className="flex min-w-0 flex-1 flex-col gap-4">
				<div className="flex flex-col gap-[5px]">
					<Block className="h-4 w-32" />
					<Block className="h-[3px] w-full" />
				</div>
				<Block className="h-7 w-3/4" />
				<div className="flex flex-col gap-2">
					<Block className="h-3.5 w-full" />
					<Block className="h-3.5 w-full" />
					<Block className="h-3.5 w-full" />
					<Block className="h-3.5 w-full" />
					<Block className="h-3.5 w-full" />
					<Block className="h-3.5 w-2/5" />
				</div>
			</div>
		</div>
	);
}

/** One row of the 2-column grid; the backend caps at three and rarely fills them. */
const SKELETON_CARDS = [0, 1];

export function NgoCampaignsGridSkeleton() {
	return (
		<div className="grid gap-6 xl:grid-cols-2">
			{SKELETON_CARDS.map((index) => (
				<NgoCampaignCardSkeleton key={index} />
			))}
		</div>
	);
}
